import React from "react";
import { C } from "../../../utils/constants";

import "./Spinner.css";

/**
 * Gradient Spinner (Reusable)
 *
 * Props:
 * - size: number (default 44)
 * - speed: number (seconds per rotation, default 1)
 * - showTrack: boolean (background ring)
 */
function Spinner({
    size = 44,
    speed = 1,
    showTrack = true,
}) {
    return (
        <div
            className="custom-spinner"
            style={{
                width: size,
                height: size,
                position: "relative",
                display: "inline-block",
            }}
        >
            {/* Gradient rotating ring */}
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    background: `conic-gradient(
            ${C.teal},
            ${C.cyan},
            ${C.orange},
            ${C.teal}
          )`,
                    animation: `spin ${speed}s linear infinite`,
                    filter: "blur(0.5px)",
                }}
            />

            {/* Inner cut (creates ring effect) */}
            <div
                style={{
                    position: "absolute",
                    inset: showTrack ? 4 : 6,
                    borderRadius: "50%",
                    background: "#0b0f14", // match your app bg
                }}
            />

            {/* Optional subtle track ring */}
            {showTrack && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        borderRadius: "50%",
                        border: "1px solid rgba(255,255,255,0.06)",
                    }}
                />
            )}
        </div>
    );
}

export default Spinner;

/**
 * Centered Loader (Full page / section)
 */
export function ProbestackSpinner({ text = "" }) {
    return (
        <div
            className="spinner-wrapper"
            style={{
                width: "100%",
                padding: "40px 0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
            }}
        >
            <Spinner />
            <div
                style={{
                    fontSize: 12,
                    color: "rgba(255,255,255,0.55)",
                    letterSpacing: "0.05em",
                }}
            >
                {text}
            </div>
        </div>
    );
}